import { useHideOriginTitlebar } from '@/pages/ISWAN_APP/layout/hooks/useHideOriginTitleBar/useHideOriginTitlebar';
import NavBar from '@/pages/ISWAN_APP/layout/NavBar/NavBar';
import { useLocation } from '@umijs/max';
import React from 'react';
import s from './layout.less';
import { H5Navbar } from '@/pages/ISWAN_APP/layout/H5CommonLayout/H5Navbar/h5Navbar';

export interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = (props) => {
  useHideOriginTitlebar();
  const { pathname } = useLocation();

  function getBgColor() {
    if (pathname === '/app/workspace') {
      return '#f4f7ff';
    }
    if (pathname === '/app/aiChat') {
      return '#ffffff';
    }
  }

  if (pathname.includes('/prepareEnv')) {
    return <>{props.children}</>;
  }

  if (pathname.includes('/singleEnv')) {
    return <>{props.children}</>;
  }

  if (pathname.includes('/app/guide')) {
    return <>{props.children}</>;
  }

  if (pathname === '/app/login') {
    return <>{props.children}</>;
  }

  if (pathname.includes('/app/fireWatch')) {
    return <>{props.children}</>;
  }
  // 如果是H5页面 动态判断是否需要 Navbar
  if (pathname.includes('/h5')) {
    if (['/h5/noAuth', '/h5/empty'].includes(pathname)) {
      return (<>{props.children}</>)
    } else {
      return <H5Navbar>
        {props.children}
      </H5Navbar>
    }
  }
  return (
    <div className={s.main} style={{ backgroundColor: getBgColor() }}>
      <div className={s.navbar}>
        <NavBar />
      </div>
      <div className={s.body}>{props.children}</div>
    </div>
  );
};

export default Layout;
